import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService, ResponseResult } from 'sv-shared';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TramDoService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.thmpEndpoint}/tramdo`);
  }

  find(model: any) {
    var url = `${this.serviceUri}/find`;
    return this.defaultPost(url, model);
  }

  getsAllByUser() {
    var url = `${this.serviceUri}/GetsAllByUser`;
    return this.defaultGet(url);
  }

  getsMyTramDo() {
    var url = `${this.serviceUri}/GetsMyTramDo`;
    return this.defaultGet(url);
  }

  getsByIdCustomer(idCustomer: number) {
    var url = `${this.serviceUri}/GetsByIdCustomer/${idCustomer}`;
    return this.defaultGet(url);
  }

  getsByUserId(userId: number) {
    var url = `${this.serviceUri}/GetsByUserId/${userId}`;
    return this.defaultGet(url);
  }
}
